import registrationInstance from '../../instance'

const getCompanyActivationData = () => {
	return registrationInstance.get('/company/data/activation')
}

export default getCompanyActivationData
